import React, { useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";

import Grid from '@material-ui/core/Grid';
import Typography from "@material-ui/core/Typography";
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';

const useStyles = makeStyles(theme => ({
    form: {
        minHeight: 400
    },
    marginTop: {
        marginTop: theme.spacing(3)
    },
    total: {
        marginTop: theme.spacing(1)
    },
}));

export default function ChargeForm(props) {

    const { paymentItem, paymentAmount, paymentSucceeded, loading, setLoading } = props;

    const stripe = useStripe();
    const elements = useElements();
    const classes = useStyles();

    const [ alertMessage, setAlertMessage ] = useState(null);
    const [ alertSeverity, setAlertSeverity ] = useState('warning');

    const handleSubmit = async (e) => {
        e.preventDefault();

        setAlertMessage(null);

        if (!stripe || !elements) {
            // Stripe.js hasn't yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        setLoading(true);

        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
            // Make sure to change this to your payment completion page
            return_url: window.location.href + '?form="payment_complete',
            },
            redirect: 'if_required', // Only redirect if necessary
        });

        // This point will only be reached if there is an immediate error when
        // confirming the payment. Otherwise, your customer will be redirected to
        // your `return_url`. For some payment methods like iDEAL, your customer will
        // be redirected to an intermediate site first to authorize the payment, then
        // redirected to the `return_url`.
        console.log(error);
        if (error?.type === "card_error" || error?.type === "validation_error") {
            setAlertMessage(error.message);
            setAlertSeverity("warning");
        } else if (error) {
            setAlertMessage("An unexpected error occurred.");
            setAlertSeverity("warning");
        } else {
            setAlertMessage("Payment Successful!");
            setAlertSeverity("success");

            paymentSucceeded();
        }

        setLoading(false);
    };

    const paymentElementOptions = {

    }

return (
    <form id="payment-form" onSubmit={handleSubmit} className={classes.form}>

        <PaymentElement id="payment-element" options={paymentElementOptions} />

        <div className={classes.marginTop}>
            <Grid container spacing={1} justifyContent="space-between" alignItems="center">
                <Grid item>
                    <Typography
                        align="right"
                        variant="subtitle2"
                        color="primary"
                        >
                        {paymentItem}
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography align="right" variant="subtitle2" color="textPrimary">
                        {(paymentAmount / 100).toLocaleString("en-US", {style:"currency", currency:"USD"})}
                    </Typography>
                </Grid>
            </Grid>
        </div>

        <Button 
            fullWidth 
            type="submit" 
            disabled={loading || !stripe || !elements || (alertSeverity==="success")} 
            id="submit"
            className={classes.marginTop}
            variant="contained"
            color="primary"
            >
            Pay Now
        </Button>
        {(alertMessage) &&
            <Alert severity={alertSeverity} className={classes.marginTop}>
                {alertMessage}
            </Alert>
        }
    </form>
);
}